var $009bbbb440d0e907$exports = {};
$009bbbb440d0e907$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izv\u{113}l\u{113}ties vienumu`,
    "tableResizer": `Izm\u{113}ra main\u{12B}t\u{101}js`
};


export {$009bbbb440d0e907$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
